import React, { useEffect, useState } from "react";
import { getPageData } from "../api/pageService";
import { sleep } from "../utils/sleep";
import { Title, Meta, Link as SeoLink } from "react-head";
import "../AboutUs.css";
import OurImpact from "../components/OurImpact";
import ClientLogos from "../components/ClientLogos";
import OurStory from "../components/OurStory";
import CoreBelief from "../components/CoreBelief";
import CTA from "../components/CTA";

const AboutUs = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
        const fetchPageData = async () => {
          try {
            // simulate network delay (3 sec)
            //await sleep(3000);
  
            const data = await getPageData("about"); // asynchronous call
            setPageData(data);
          } catch (err) {
            setError("Failed to load about page data.");
          } finally {
            setLoading(false);
          }
        };
    
        fetchPageData();
  }, []);
  
  return (
    <>
      <Title>{pageData? pageData.seo.title:''}</Title>
      <Meta
        name="description"
        content={pageData?pageData.seo.description:''}
      />
      <SeoLink rel="canonical" href={pageData?pageData.seo.canonical:''} />
    <div className="about-us-page">
        {/* Hero Section */}
        {(loading || error) ? (
          <section className="about-hero text-white text-center d-flex align-items-center">
        <div className="container">
          <h2 className="fw-bold placeholder-glow">
            <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </h2>
          <p className="small ps-3 placeholder-glow">
             <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </p>
        </div>
      </section>
          ) : (
            <section className="about-hero text-white text-center d-flex align-items-center">
        <div className="container">
          <h2 className="fw-bold ">{pageData?pageData.hero.heading:''} <span className="text-primary-color">{pageData?pageData.hero.highlight:''}</span></h2>
          <p className="small ps-3">
            {pageData?pageData.hero.description:''}
          </p>
        </div>
      </section>
          )}
      

      {/* Our Story */}
      <OurStory/>

      {/* Mission, Vision, Values */}
      <CoreBelief />

      {/* OurImpact */}
      <OurImpact />

      {/* ClientLogos */}
      <ClientLogos />

      {/* Call to Action */}
      <CTA/>

      </div>
      </>
  );
};

export default AboutUs;
